export const MainConfig = {
  backendEndpoint: "https://studio.retorik.ai/CHU_BordeauxV2",
  apiKey: "K2",
  apiSecret: "K2",
};
